import './index.scss';

import React from 'react';
import Tooltip from '@/components/common/Elements/Tooltip/Tooltip';
import clsx from 'clsx';

export const SWITCH_CLASS_IDENTIFIER = 'switchModule';
export const DISABLED_CLASS = 'unavailable';
export const READONLY_CLASS = 'readonly';
export const ACTIVE_CLASS = 'active';
export const TOOLTIP_TEST_ID = 'childTooltip';

const SwitchComponent = (props) => {
  const {
    disabled,
    isActive,
    onChange,
    children,
    className = '',
    readonly = false,
    ...otherProps
  } = props;

  const onClick = !disabled && !readonly ? onChange : null;

  return (
    <div
      className={clsx(
        'switchModule',
        isActive && ACTIVE_CLASS,
        disabled && DISABLED_CLASS,
        readonly && READONLY_CLASS,
        className
      )}
      role="button"
      onClick={onClick}
      {...otherProps}
    >
      <span></span>
      {children}
    </div>
  );
};
class Switch extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { tooltip } = this.props;

    if (tooltip) {
      const { place = 'left', effect = 'solid' } = tooltip;

      return (
        <SwitchComponent {...this.props} data-tooltip-id={tooltip.id}>
          <Tooltip
            className={tooltip.tooltipClasses}
            id={tooltip.id}
            place={place}
            effect={effect}
          >
            <div data-testid={TOOLTIP_TEST_ID}>{tooltip.content}</div>
          </Tooltip>
        </SwitchComponent>
      );
    }

    return <SwitchComponent {...this.props} />;
  }
}

export default Switch;
